export type inputType =
    | 'button'
    | 'checkbox'
    | 'color'
    | 'date'
    | 'datetime-local'
    | 'email'
    | 'file'
    | 'hidden'
    | 'image'
    | 'month'
    | 'number'
    | 'password'
    | 'range'
    | 'radio'
    | 'search'
    | 'submit'
    | 'text'
    | 'tel'
    | 'time'
    | 'url'
    | 'week';

export const inputTypes = [
    'button',
    'checkbox',
    'color',
    'date',
    'datetime-local',
    'email',
    'file',
    'hidden',
    'image',
    'month',
    'number',
    'password',
    'radio',
    'range',
    'search',
    'submit',
    'tel',
    'text',
    'time',
    'url',
    'week',
];
